
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"2_SP_Comp","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"NP_01_お友達紹介-","transform":"translate(-221 -441)"}},[_c('g',{attrs:{"id":"Group-2","transform":"translate(221 441)"}},[_c('rect',{attrs:{"id":"Rectangle-Copy","stroke":"#000064","x":".5","y":".5","width":"47","height":"47","rx":"4"}}),_c('g',{attrs:{"id":"Group-6","transform":"translate(15 22)","fill":"#000064"}},[_c('circle',{attrs:{"id":"Oval","cx":"2","cy":"2","r":"2"}}),_c('circle',{attrs:{"id":"Oval-Copy","cx":"9","cy":"2","r":"2"}}),_c('circle',{attrs:{"id":"Oval-Copy-2","cx":"16","cy":"2","r":"2"}})])])])])])
          )
        }
      }
    